import * as React from "react";

import { Input } from "@/components/ui/input";
import { currencySymbol } from "@/lib/format";
import { cn } from "@/lib/utils";

type CurrencyInputProps = Omit<React.ComponentPropsWithoutRef<"input">, "onChange" | "type" | "value"> & {
  value: string;
  onValueChange: (value: string) => void;
  currency: string;
};

export function CurrencyInput({ value, onValueChange, currency, className, ...props }: CurrencyInputProps) {
  return (
    <div className="relative w-full">
      <Input
        {...props}
        type="text"
        inputMode="decimal"
        value={value}
        onChange={(event) => onValueChange(event.currentTarget.value)}
        className={cn("pr-16 tabular-nums", className)}
      />
      <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-sm font-medium text-muted-foreground">
        {currencySymbol(currency)}
      </span>
    </div>
  );
}
